import { Loader } from 'google-maps'

export class LoaderSingleton extends Loader {
  constructor(apiKey, option) {
    if (!LoaderSingleton.instance) {
      super(apiKey, option)
      LoaderSingleton.instance = this
    }

    return LoaderSingleton.instance
  }
}

/**
 * マーカーSVGを生成してdataURI化
 * @param {Object} data 対象スペースデータ
 */
export const getMarkerDataURL = (data, targetId) => {
  if (data.type === 'space') {
    return data.placeId === targetId
      ? require('@/assets/image/map/pin-sp-selected.png')
      : require('@/assets/image/map/pin-sp-unselected.png')
  } else if (data.type === 'event') {
    return data.placeId === targetId
      ? require('@/assets/image/map/pin-ev-selected.png')
      : require('@/assets/image/map/pin-ev-unselected.png')
  }

  // event(#95bb00) or space(#12b6d4)
  const baseColor = data.type === 'event' ? '#95bb00' : '#12b6d4'
  const fill = data.placeId === targetId ? baseColor : '#fff'
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="28.76" height="38" viewBox="0 0 28.76 38">
      <g id="ピン-スペース_未選択時_" data-name="ピン-スペース(未選択時)" transform="translate(1 1)" style="isolation: isolate">
        <path id="パス_478" data-name="パス 478" d="M26.76,13.38A13.38,13.38,0,1,0,.88,18.158h0l.007.018a13.321,13.321,0,0,0,.772,1.658A96.989,96.989,0,0,0,12.016,35.389l.025.028a1.357,1.357,0,0,0,.107.106,1.83,1.83,0,0,0,2.464,0,1.211,1.211,0,0,0,.107-.106l.025-.028A96.987,96.987,0,0,0,25.1,19.835a13.279,13.279,0,0,0,.772-1.659l.007-.017h0a13.349,13.349,0,0,0,.88-4.779" fill="#fff"/>
        <path id="パス_478-2" data-name="パス 478" d="M26.76,13.38A13.38,13.38,0,1,0,.88,18.158h0l.007.018a13.321,13.321,0,0,0,.772,1.658A96.989,96.989,0,0,0,12.016,35.389l.025.028a1.357,1.357,0,0,0,.107.106,1.83,1.83,0,0,0,2.464,0,1.211,1.211,0,0,0,.107-.106l.025-.028A96.987,96.987,0,0,0,25.1,19.835a13.279,13.279,0,0,0,.772-1.659l.007-.017h0a13.349,13.349,0,0,0,.88-4.779M13.38,18.891a5.511,5.511,0,1,1,5.511-5.511,5.511,5.511,0,0,1-5.511,5.511" fill="${fill}" stroke="${baseColor}" stroke-width="2"/>
      </g>
    </svg>
  `
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}

/**
 * マーカーに表示するテキストの幅を取得
 * @param {String} text 表示するテキスト
 */
export const getTextWidth = (text) => {
  // create span
  const span = document.createElement('span')

  // to prevent effect to other elems, set positon on out of screen.
  span.style.position = 'absolute'
  span.style.top = '-1000px'
  span.style.left = '-1000px'

  // no wrap to get one line width
  span.style.whiteSpace = 'nowrap'

  // set span elm's params
  span.innerHTML = text
  span.style.fontSize = '18px'
  span.style.fontFamily = 'sans-serif'

  // add to DOM
  document.body.appendChild(span)

  // get width
  const width = span.clientWidth

  // delete from DOM after get width
  span.parentElement.removeChild(span)

  const offset = 30
  return width + offset
}

// ２点間の距離を計算(km)
export const getDistance = (location1, location2) => {
  const latitude1 = location1.latitude
  const longitude1 = location1.longitude;
  const latitude2 = location2.latitude
  const longitude2 = location2.longitude;

  const R = 6371; // km
  const diffLatitudeRadian = getRadian(latitude2 - latitude1);
  const diffLongitudeRadian = getRadian(longitude2 - longitude1);
  const latitudeRadian = getRadian(latitude1);
  const longitudeRadian = getRadian(latitude2);

  const a = Math.sin(diffLatitudeRadian / 2) *
      Math.sin(diffLatitudeRadian / 2) +
      Math.sin(diffLongitudeRadian / 2) *
      Math.sin(diffLongitudeRadian / 2) *
      Math.cos(latitudeRadian) *
      Math.cos(longitudeRadian);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

const getRadian = value => {
  return value * Math.PI / 180;
}

export const currentLocationMarkerSvg = () => {
  // const svg = `
  //   <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 400 400">
  //     <circle cx="200" cy="200" r="100" fill="blue" opacity="0.7"/>
  //   </svg>
  // `
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 46.8 30.8"><path fill="#F6AB00" d="M38.1 26.9H8.7c-4.2 0-7.6-3.4-7.6-7.6v-2.2c0-8.9 7.2-16 16-16h19.5c5.1 0 9.2 4.1 9.2 9.2v9.1c-.1 4.1-3.5 7.5-7.7 7.5z"/><path fill="#3E3A39" d="M38.1 28H8.7C3.9 28 0 24.1 0 19.3v-2.2C0 7.7 7.7 0 17.1 0h19.5c5.6 0 10.2 4.6 10.2 10.2v9.1c0 4.8-3.9 8.7-8.7 8.7zm-21-25.9c-8.3 0-15 6.7-15 15v2.2c0 3.6 3 6.6 6.6 6.6h29.4c3.6 0 6.6-3 6.6-6.6v-9.1c0-4.5-3.6-8.1-8.1-8.1H17.1z"/><path fill="#FFF" d="M14 14.2h-3.4c-1.5 0-2.8-1.2-2.8-2.8v-.7c0-2.3 1.9-4.1 4.1-4.1h2c1.1 0 2.1.9 2.1 2.1v3.4c.1 1.2-.8 2.1-2 2.1z"/><path fill="#3E3A39" d="M14 15.3h-3.4c-2.1 0-3.8-1.7-3.8-3.8v-.7c0-2.9 2.3-5.2 5.2-5.2h2c1.7 0 3.1 1.4 3.1 3.1v3.4c.1 1.8-1.4 3.2-3.1 3.2zm-2-7.6c-1.7 0-3.1 1.4-3.1 3.1v.7c0 .9.8 1.7 1.7 1.7H14c.6 0 1-.5 1-1V8.7c0-.6-.5-1-1-1h-2z"/><path fill="#FFF" d="M15.8 26.7c0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3 0-1.6 1.3-3 3-3 1.6 0 3 1.4 3 3z"/><path fill="#3E3A39" d="M12.8 30.7c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5.9c-1.1 0-1.9.9-1.9 2s.9 2 1.9 2c1.1 0 1.9-.9 1.9-2 0-1.2-.8-2-1.9-2z"/><path fill="#FFF" d="M37.8 26.7c0 1.7-1.4 3.1-3 3.1-1.7 0-3-1.4-3-3.1 0-1.7 1.4-3.1 3-3.1s3 1.4 3 3.1z"/><path fill="#3E3A39" d="M34.7 30.8c-2.2 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1c2.2 0 4.1 1.8 4.1 4.1s-1.8 4.1-4.1 4.1zm0-6.1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM15.2 18.8h-2.1c-.6 0-1-.5-1-1 0-.6.5-1 1-1h2.1c.6 0 1 .5 1 1s-.4 1-1 1z"/><path fill="#FFF" d="M36.2 17.7H22.6c-1.1 0-2-.9-2-2V8.5c0-1.1.9-2 2-2h13.5c1.1 0 2 .9 2 2v7.2c.1 1.1-.8 2-1.9 2z"/><path fill="#3E3A39" d="M36.2 18.8H22.6c-1.7 0-3-1.4-3-3V8.5c0-1.7 1.4-3 3-3h13.5c1.7 0 3 1.4 3 3v7.2c.1 1.7-1.3 3.1-2.9 3.1zM22.6 7.5c-.5 0-1 .4-1 1v7.2c0 .5.4 1 1 1h13.5c.5 0 1-.4 1-1V8.5c0-.5-.4-1-1-1H22.6z"/><path fill="#FFF" d="M41.3 11.4H25.4l-2.7-4.9h15.8z"/><path fill="#3E3A39" d="M41.3 12.4H25.4c-.4 0-.7-.2-.9-.5L21.8 7c-.2-.3-.2-.7 0-1 .2-.3.5-.5.9-.5h15.8c.4 0 .7.2.9.5l2.7 4.9c.2.3.2.7 0 1-.1.3-.5.5-.8.5zm-15.3-2h13.5l-1.6-2.8H24.5l1.5 2.8zM39.7 18.8H23.6c-.6 0-1-.5-1-1s.5-1 1-1h16.1c.6 0 1 .5 1 1s-.4 1-1 1z"/><path fill="#E95377" d="M28.7 10.4H26l-1.5-2.9h2.7zM34.1 10.4h-2.7l-1.6-2.9h2.7zM39.5 10.4h-2.7l-1.6-2.9h2.7z"/></svg>`

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}

export const getIcon = (data, targetId) => {
  if (data.placeId === 'current_location') {
    return {
      url: currentLocationMarkerSvg(),
      width: 30,
      height: 30,
    }
  } else {
    return {
      url: getMarkerDataURL(data, targetId),
      anchorY: 36, //Y軸の表示位置（アイコンの縦幅に合わせる）
      width: 26,
      height: 36,
    }
  }
}